import React, { useState, useEffect, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../css/calendar.css";

import ECharts, { EChartsReactProps } from "echarts-for-react";
import { useTranslation } from "react-i18next";

import { AuthMe } from "../lib/MyHttp";
import { Get, Delete } from "../lib/User";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";

import { GetList } from "../lib/DeviceData";
import { dateLang, typeSex } from "../lib/Common";

const Statistics = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { id } = useParams();
    const [data, setData] = useState({});
    const [selectDate, setSelectDate] = useState(moment().subtract(7, "d").format("YYYY-MM-DD"));
    const [selectType, setSelectType] = useState("week");
    const [items, setItems] = useState([]);
    const [xAxisData, setXAxisData] = useState([t("월요일"), t("화요일"), t("수요일"), t("목요일"), t("금요일"), t("토요일"), t("일요일")]);
    const [range1, setRange1] = useState([0, 0]);
    const [range2, setRange2] = useState([0, 0]);
    const [range3, setRange3] = useState([0, 0]);

    const [search, setSaerch] = useState({
        member_no: "",
        from: moment().subtract(7, "day").format("YYYY-MM-DD"),
        to: moment().subtract(1, "day").format("YYYY-MM-DD")
    });

    useEffect(() => {
        AuthMe(res => {
            setData(res);
            search.member_no = res.member_no;
            setSaerch({ ...search });
        });
    }, []);

    useEffect(() => {
        if (!search.member_no) {
            return;
        }

        GetList(search, res => {
            const w = [];
            const array = [];

            if (res.length > 0) {
                range1[0] = Math.min.apply(
                    null,
                    res.map(x => x.heart_min).filter(x => x !== null)
                );
                range1[1] = Math.max.apply(
                    null,
                    res.map(x => x.heart_max)
                );

                range2[0] = Math.min.apply(
                    null,
                    res.map(x => x.resp_min).filter(x => x !== null)
                );
                range2[1] = Math.max.apply(
                    null,
                    res.map(x => x.resp_max)
                );

                range3[0] = Math.min.apply(
                    null,
                    res.map(x => x.apnea_min).filter(x => x !== null)
                );
                range3[1] = Math.max.apply(
                    null,
                    res.map(x => x.apnea_max)
                );

                if (!isNaN(range1[0])) range1[0] = 0;
                if (!isNaN(range1[1])) range1[1] = 0;
                if (!isNaN(range2[0])) range2[0] = 0;
                if (!isNaN(range2[1])) range2[1] = 0;
                if (!isNaN(range3[0])) range3[0] = 0;
                if (!isNaN(range3[1])) range3[1] = 0;
            } else {
                setRange1([0, 0]);
                setRange2([0, 0]);
                setRange3([0, 0]);
            }

            let indexData = moment(search.from);
            while (indexData.isSameOrBefore(moment(search.to))) {
                w.push(selectType === "week" ? t(dateLang[indexData.format("ddd")]) : indexData.format("M/DD"));
                const d = res.find(x => x.reg_date === indexData.format("YYYY/MM/DD"));
                array.push(d ? d : {});
                indexData = indexData.add(1, "day");
            }

            setXAxisData(w);
            setItems(array);
        });
    }, [search]);

    // 심박수 컬러
    const heartColor = "#F75C5D";

    // 호흡수 컬러
    const breathColor = "#3889ff";

    // 산소불포화지수 컬러
    const oxygenColor = "#3fd3d4";

    const getOption1 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: "#dddddd",
                        width: 1
                    }
                },
                animation: true,
                formatter: function (params) {
                    if (params[0].data) {
                        return `${t("최대")} ${(parseFloat(params[0].data) + parseFloat(params[1].data) + parseFloat(params[2].data) + parseFloat(params[3].data)).toFixed()} BPM<br />${t("최소")} ${params[0].data} BPM`;
                    }
                    return "";
                },
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                splitLine: {
                    show: true
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#333333",
                    fontWeight: "bolder",
                    fontSize: 13,
                    fontFamily: "Pretendard"
                },
                data: xAxisData
            },
            yAxis: {
                type: "value",
                // splitNumber: 12,
                axisLabel: {
                    color: "#333333",
                    fontWeight: "bolder",
                    fontSize: 13,
                    fontFamily: "Pretendard"
                },
                min: 0,
                max: 150
            },
            grid: {
                top: 20,
                left: 50,
                right: 10,
                bottom: 25
            },
            series: [
                {
                    name: "Placeholder",
                    type: "bar",
                    stack: "Total",
                    silent: true,
                    itemStyle: {
                        borderColor: "transparent",
                        color: "transparent"
                    },
                    data: items.map(x => x.heart_min)
                },
                {
                    name: "Value",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        color: heartColor,
                        borderRadius: 15
                    },
                    barWidth: selectType === "week" ? 20 : "50%",
                    data: items.map(x => parseInt(x.heart_avg) - 1 - x.heart_min)
                },
                {
                    name: "Placeholder-Average",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        borderColor: "transparent",
                        color: "transparent"
                    },
                    data: items.map(x => 2)
                },
                {
                    name: "Value",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        color: heartColor,
                        borderRadius: 15
                    },
                    barWidth: selectType === "week" ? 20 : "50%",
                    data: items.map(x => x.heart_max - (parseInt(x.heart_avg) + 1))
                }
            ]
        };
    };

    const getOption2 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: "#dddddd",
                        width: 1
                    }
                },
                animation: true,
                formatter: function (params) {
                    if (params[0].data) {
                        return `${t("최대")} ${(parseFloat(params[0].data) + parseFloat(params[1].data) + parseFloat(params[2].data) + parseFloat(params[3].data)).toFixed()} ${t("회")}/${t("분")}<br />${t("최소")} ${params[0].data} ${t("회")}/${t("분")}`;
                    }
                    return "";
                },
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                splitLine: {
                    show: true
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#333333",
                    fontWeight: "bolder",
                    fontSize: 13,
                    fontFamily: "Pretendard"
                },
                data: xAxisData
            },
            yAxis: {
                type: "value",
                // splitNumber: 12,
                axisLabel: {
                    color: "#333333",
                    fontWeight: "bolder",
                    fontSize: 13,
                    fontFamily: "Pretendard"
                },
                min: 0,
                max: 40
            },
            grid: {
                top: 20,
                left: 50,
                right: 10,
                bottom: 25
            },
            series: [
                {
                    name: "Placeholder",
                    type: "bar",
                    stack: "Total",
                    silent: true,
                    itemStyle: {
                        borderColor: "transparent",
                        color: "transparent"
                    },
                    data: items.map(x => x.resp_min)
                },
                {
                    name: "Value",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        color: breathColor,
                        borderRadius: 20
                    },
                    barWidth: selectType === "week" ? 20 : "50%",
                    data: items.map(x => parseInt(x.resp_avg) - 1 - x.resp_min)
                },
                {
                    name: "Placeholder-Average",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        borderColor: "transparent",
                        color: "transparent"
                    },
                    data: items.map(x => 2)
                },
                {
                    name: "Value",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        color: breathColor,
                        borderRadius: 20
                    },
                    barWidth: selectType === "week" ? 20 : "50%",
                    data: items.map(x => x.resp_max - (parseInt(x.resp_avg) + 1))
                }
            ]
        };
    };

    const getOption3 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: "#dddddd",
                        width: 1
                    }
                },
                animation: true,
                formatter: function (params) {
                    if (params[0].data) {
                        return `${t("최대")} ${(parseFloat(params[0].data) + parseFloat(params[1].data) + parseFloat(params[2].data) + parseFloat(params[3].data)).toFixed()} %<br />${t("최소")} ${params[0].data} %`;
                    }
                    return "";
                },
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                splitLine: {
                    show: true
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#333333",
                    fontWeight: "bolder",
                    fontSize: 13,
                    fontFamily: "Pretendard"
                },
                data: xAxisData
            },
            yAxis: {
                type: "value",
                // splitNumber: 12,
                axisLabel: {
                    color: "#333333",
                    fontWeight: "bolder",
                    fontSize: 13,
                    fontFamily: "Pretendard"
                },
                min: 80,
                max: 100
            },
            grid: {
                top: 20,
                left: 50,
                right: 10,
                bottom: 25
            },
            series: [
                {
                    name: "Placeholder",
                    type: "bar",
                    stack: "Total",
                    silent: true,
                    itemStyle: {
                        borderColor: "transparent",
                        color: "transparent"
                    },
                    data: items.map(x => x.apnea_min)
                },
                {
                    name: "Value",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        color: oxygenColor,
                        borderRadius: 15
                    },
                    barWidth: selectType === "week" ? 20 : "50%",
                    data: items.map(x => parseInt(x.apnea_avg) - 1 - x.apnea_min)
                },
                {
                    name: "Placeholder-Average",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        borderColor: "transparent",
                        color: "transparent"
                    },
                    data: items.map(x => 2)
                },
                {
                    name: "Value",
                    type: "bar",
                    stack: "Total",
                    itemStyle: {
                        color: oxygenColor,
                        borderRadius: 15
                    },
                    barWidth: selectType === "week" ? 20 : "50%",
                    data: items.map(x => x.apnea_max - (parseInt(x.apnea_avg) + 1))
                }
            ]
        };
    };

    return (
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("통계")}</h2>
                <h3 className="sub_title_sm">Statistics</h3>

                <section className="calendar-normal-box">
                    <div className="in">
                        <Calendar
                            formatDay={(locale, date) => date.toLocaleString("en", { day: "numeric" })}
                            selectRange={false}
                            next2Label={null}
                            prev2Label={null}
                            showNeighboringMonth={false}
                            value={moment(selectDate).toDate()}
                            onChange={date => {
                                const d = moment(date);
                                setSelectDate(d.format("YYYY-MM-DD"));
                                if (selectType === "week") {
                                    setSaerch({
                                        ...search,
                                        from: d.format("YYYY-MM-DD"),
                                        to: d.add(6, "day").format("YYYY-MM-DD")
                                    });
                                } else if (selectType === "month") {
                                    setSaerch({
                                        ...search,
                                        from: d.format("YYYY-MM-DD"),
                                        to: d.add(29, "day").format("YYYY-MM-DD")
                                    });
                                }
                            }}
                        />
                    </div>
                </section>

                <h4 className="statistics_sub_tit">
                    {t("주간")}/{t("월간")} {t("통계")}
                </h4>

                <div className="tab_statistics_wrapper">
                    <ul className="tab_statistics">
                        <li
                            className={selectType === "week" ? "active" : ""}
                            onClick={() => {
                                const d = moment(selectDate);
                                setSaerch({
                                    ...search,
                                    from: d.format("YYYY-MM-DD"),
                                    to: d.add(6, "day").format("YYYY-MM-DD")
                                });
                                setSelectType("week");
                            }}
                        >
                            <a href="javascript:;">Weekly</a>
                        </li>
                        <li
                            className={selectType === "month" ? "active" : ""}
                            onClick={() => {
                                const d = moment(selectDate);
                                setSaerch({
                                    ...search,
                                    from: d.format("YYYY-MM-DD"),
                                    to: d.add(29, "d").format("YYYY-MM-DD")
                                });
                                setSelectType("month");
                            }}
                        >
                            <a href="javascript:;">Monthly</a>
                        </li>
                    </ul>
                </div>

                {selectType === "week" && (
                    <section className="stat_tab_cont weekly_graph">
                        <article className="graph_ar">
                            <div className="top">
                                <span className="icons circle heart"></span>
                                <span className="tit">{t("심박수 범위")}</span>
                                <span className="data">
                                    <b>
                                        {range1[0]}~{range1[1]}
                                    </b>{" "}
                                    BPM
                                </span>
                                <span className="date">
                                    {moment(search.from).format(t("YYYY년 MM월 DD일"))} ~ {moment(search.to).format(t("MM월 DD일"))}
                                </span>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption1()} opts={{ renderer: "svg", width: "auto", height: "auto" }} />
                            </div>
                        </article>
                        <article className="graph_ar">
                            <div className="top">
                                <span className="icons circle breath"></span>
                                <span className="tit">{t("호흡수 범위")}</span>
                                <span className="data">
                                    <b>
                                        {range2[0]}~{range2[1]}
                                    </b>{" "}
                                    {t("회")}/{t("분")}
                                </span>
                                <span className="date">
                                    {moment(search.from).format(t("YYYY년 MM월 DD일"))} ~ {moment(search.to).format(t("MM월 DD일"))}
                                </span>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption2()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>
                        {/* <article className="graph_ar">
                            <div className="top">
                                <span className="icons circle oxygen"></span>
                                <span className="tit">{t("산소탈포화지수 범위")}</span>
                                <span className="data">
                                    <b>
                                        {range3[0]}~{range3[1]}
                                    </b>{" "}
                                    %
                                </span>
                                <span className="date">
                                    {moment(search.from).format(t("YYYY년 MM월 DD일"))} ~ {moment(search.to).format(t("MM월 DD일"))}
                                </span>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption3()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article> */}
                    </section>
                )}

                {/* monthly 그래프 */}
                {selectType === "month" && (
                    <section className="stat_tab_cont monthly_graph">
                        <article className="graph_ar">
                            <div className="top">
                                <span className="icons circle heart"></span>
                                <div className="text_box">
                                    <p className="tit">
                                        <b>
                                            {t("심박수 범위")} {range1[0]}~{range1[1]}
                                        </b>{" "}
                                        BPM
                                    </p>
                                    <p className="date">
                                        {moment(search.from).format(t("MM월 DD일"))} ~ {moment(search.to).format(t("MM월 DD일"))}
                                    </p>
                                </div>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption1()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>
                        <article className="graph_ar">
                            <div className="top">
                                <span className="icons circle breath"></span>
                                <div className="text_box">
                                    <p className="tit">
                                        <b>
                                            {t("호흡수 범위")} {range2[0]}~{range2[1]}
                                        </b>{" "}
                                        {t("회")}/{t("분")}
                                    </p>
                                    <p className="date">
                                        {moment(search.from).format(t("MM월 DD일"))} ~ {moment(search.to).format(t("MM월 DD일"))}
                                    </p>
                                </div>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption2()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>
                        {/* <article className="graph_ar">
                            <div className="top">
                                <span className="icons circle oxygen"></span>
                                <div className="text_box">
                                    <p className="tit">
                                        <b>
                                            {t("산소탈포화지수 범위")} {range3[0]}~{range3[1]}
                                        </b>{" "}
                                        {t("회")}/{t("분")}
                                    </p>
                                    <p className="date">
                                        {moment(search.from).format(t("MM월 DD일"))} ~ {moment(search.to).format(t("MM월 DD일"))}
                                    </p>
                                </div>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption3()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article> */}
                    </section>
                )}
            </div>
        </main>
    );
};

export default Statistics;
